import React, { Component } from 'react';
import { Icon, Input, Tag, Tooltip } from 'antd';

class TagsInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputVisible: false,
      inputValue: '',
    };
  }

  handleClose = removedTag => {
    const tags = this.props.tags.filter(tag => tag.uid !== removedTag.uid);
    this.props.handleSetTags(tags);
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.props;
    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, { name: inputValue, uid: Date.now() }];
      this.props.handleSetTags(tags);
    }
    this.setState({
      inputVisible: false,
      inputValue: '',
    });
  };

  render() {
    const { inputVisible, inputValue } = this.state;
    return (
      <div>
        {this.props.tags.map(item => {
          const isLongTag = item.name.length > 20;
          const tagElem = (
            <Tag key={item.uuid || item.uid} closable onClose={() => this.handleClose(item)}>
              {isLongTag ? `${item.name.slice(0, 20)}...` : item.name}
            </Tag>
          );
          return isLongTag ? (
            <Tooltip title={item.name} key={item.uuid || item.uid}>
              {tagElem}
            </Tooltip>
          ) : (
            tagElem
          );
        })}
        {inputVisible && (
          <Input
            ref={input => {
              this.input = input;
            }}
            type="text"
            size="small"
            style={{ width: 78 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {!inputVisible && (
          <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
            <Icon type="plus" /> New Tag
          </Tag>
        )}
      </div>
    );
  }
}

export default TagsInput;



// WEBPACK FOOTER //
// ./src/components/comm/TagsInput.js